import React, { Component } from 'react';
import classnames from 'classnames';
import debounce from 'lodash/debounce';

import propTypes, { defaultProps } from './props';

export const buildBlankPageUrl =
  (urlBase, { version, themeId, themeAssemblyVersion } = {}) =>
    `${urlBase}?ver=${version || ''}${themeId || ''}${themeAssemblyVersion || ''}`;

export class WaBonaEditor extends Component
{
  static propTypes = propTypes;

  static defaultProps = defaultProps;

  constructor(props)
  {
    super(props);

    const { isOnlyLoad, callback } = props;

    this.isOnlyLoad = !!isOnlyLoad;
    this.callback = callback;

    if (!this.isOnlyLoad)
    {
      const { editorConfig: { editorId, idIn, idOut }, dataChangedTimeout } = props;

      this.isOnlyCreate = !!idIn;
      this.idIn = idIn || `${editorId}-In`;
      this.idOut = idOut || `${editorId}-Out`;
      this.createWaEditor = this.createWaEditor.bind(this);
      this.onEditorDataChanged = debounce(this.onEditorDataChanged.bind(this), dataChangedTimeout);
    }
  }

  componentDidMount()
  {
    if (!this.isOnlyLoad)
    {
      this.createWaEditor();
    }

    this.callback();
  }

  shouldComponentUpdate()
  {
    return false;
  }

  componentWillUnmount()
  {
    if (!this.editor) { return; }

    this.editor.EditorDataChanged.removeHandler(this.onEditorDataChanged);
    this.onEditorDataChanged.cancel();
    this.editor.unload();
    this.toolbar.unload();
    this.editor = null;
  }

  onEditorDataChanged()
  {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onDataChanged(
      this.editor.getData()
    );
  }

  createWaEditor()
  {
    const { editorConfig, toolbarConfig } = this.props;
    const { toolbarContainerId, pToolbarStruct, args = {} } = toolbarConfig;

    this.toolbar = WA.topWindow.BEditor.ToolbarsManager.createToolbar(
      window,
      toolbarContainerId,
      pToolbarStruct,
      { ...args, isReactComponentEditor: true }
    );

    const {
      editorId, blankPageURL, displayMode, toolbarConfigKey, autoStart, autoFocus,
      minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles, extParameters
    } = editorConfig;

    const env =
      {
        version: WA.version,
        themeId: WA.themeId,
        themeAssemblyVersion: WA.themeAssemblyVersion
      };

    this.editor = WA.topWindow.BEditor.EditorsManager.createEditor(
      editorId, this.idIn, this.idOut, buildBlankPageUrl(blankPageURL, env), displayMode,
      this.toolbar, WA.topWindow[toolbarConfigKey], autoStart, autoFocus,
      minEditorHeight, mainIdForBodyStyles, mainClassForBodyStyles,
      {
        isTidyServiceOn: WA.AdminPanel.Resources.AdminEditor.isTidyServiceOn,
        ...extParameters,
        isReactComponentEditor: true
      }
    );
    this.editor.initEditor(displayMode);
    this.editor.EditorDataChanged.addHandler(this.onEditorDataChanged);
  }

  render()
  {
    if (!this.isOnlyLoad && !this.isOnlyCreate)
    {
      const {
        className,
        targetWidth,
        style: propsStyle,
        editorConfig: { minEditorHeight },
        content
      } = this.props;

      const classNames = classnames('-wa-html-editor', className);
      const widthStyle = targetWidth ? { width: targetWidth } : {};
      const minHeightStyle = minEditorHeight ? { minHeight: `${minEditorHeight}px` } : {};
      const style = { ...propsStyle, ...widthStyle };
      const inContainerStyle = { ...widthStyle, ...minHeightStyle };

      return (
        <div className={classNames} style={style}>
          {!this.isOnlyCreate &&
          (
            <div
              id={this.idIn}
              style={inContainerStyle}
              ref={(inContainer) => { this.inContainer = inContainer; }}
              dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
                __html: content
              }}
            />
          )}
          <input type="hidden" id={this.idOut} />
        </div>
      );
    }

    return null;
  }
}